export default __webpack_public_path__ + "static/media/hamburger-bell.6167810f.svg";